import { getConfigValue } from "@jutro/config";
import { useGenericAuth } from "./generic/useGenericAuth";
import { useOktaAuth } from "./okta/useOktaAuth";
export var useAuth = function () {
  var oktaAuth = useOktaAuth(),
    genericAuth = useGenericAuth();
  return !oktaAuth && !!genericAuth || getConfigValue("JUTRO_AUTH_GENERIC_CLIENT", !1) ? genericAuth : oktaAuth;
};